import React, { useState } from 'react';
import { SelectProps } from 'antd/es/select';
import { get } from 'lodash';
import { FormInstance } from 'rc-field-form';
import { TAutoComplete } from 'modules/main';
import { AutoComplete } from 'antd';

type TAutoCompleteProps = {
  form: FormInstance;
  name: (string | number)[] | string;
  children: React.ReactNode;
  defaultValue?: string;
  onChange?: (value: string | number | undefined) => void;
  promise: any;
  board?: string;
};

export const AutoCompleteInputUniv = ({
  form,
  name,
  defaultValue,
  children,
  onChange,
  promise,
  board,
}: TAutoCompleteProps) => {
  const [options, setOptions] = useState<SelectProps<object>['options']>([]);

  function triggerChange(changedValue: string | number | undefined) {
    onChange && onChange(changedValue);
  }

  function onValueChange(v: string | number | undefined) {
    triggerChange(v);
  }

  //input에 값을 넣을 때마다 handleSearch실행 value=사용자가 입력한 값
  async function handleSearch(value: string) {
    if (board === 'community') {
      try {
        form.setFields([{ name: name, value: value }]);
        let response = await promise({ params: { pageSize: 7, q: value } });
        setOptions(
          get(response, 'data.contents', [])?.map((item: any) => {
            return {
              label: get(item, 'university_name'), //label 값은 보여지기 때문에 실제 회사 이름으로 세팅
              value: get(item, 'id'), //value는 해당 회사의 아이디값을 가질수 있도록
            };
          }),
        );
      } catch (e) {
        throw e;
      }
    } else {
      try {
        form.setFields([{ name: name, value: value }]);
        let response = await promise({ params: { pageSize: 7, q: value } });
        setOptions(
          get(response, 'data.contents', [])?.map((item: TAutoComplete) => {
            return { value: get(item, 'value') };
          }),
        );
      } catch (e) {
        throw e;
      }
    }
  }

  return (
    <AutoComplete
      style={{ width: '100%' }}
      options={options} //사용자가 입력한 값을 바탕으로 서버에서 불러온 옵션들
      onSearch={handleSearch} //입력한 값에 따라 서버에 데이터 get요청/ setOptions 하는 함수
      defaultValue={defaultValue}
      value={form.getFieldValue(name)} //사용자가 입력한 값
      disabled={get(children, 'props.disabled', false)}
      onSelect={(value, option) => {
        if (board === 'community') {
          form.setFields([
            {
              name: name,
              value: option.label,
            },
            { name: 'university_id', value: option.value },
          ]);
        } else {
          form.setFields([{ name: name, value: value }]);
        }
      }} //사용자가 드롭다운옵션 중 하나를 선택했을 때 Form.Item에 value 세팅
      children={children}
      onChange={onValueChange}
    />
  );
};
